// Module
var code = "<div class=\"login-form-container\"> <div id=\"hiw-login-container\"></div> </div> ";
// Exports
export default code;